import { useEffect, useState } from "react";

import {
  Paper,
  TextField,
  InputAdornment,
  FormControlLabel,Checkbox,Typography
} from "@mui/material";

import BillToTable  from "./components/BillToTable";
import IconButton from "@mui/material/IconButton";
import SearchIcon from "@mui/icons-material/Search";
import CloseIcon from "@mui/icons-material/Close";
import PermissionWrapper from "../../Setting/PermissionWrapper";

export default function BillToTableContainer(props) {
  const {
    setSelectedRow,
    rows,
    isLoading,
    billToTableApiCall,
    rowsCount,
    setAddNewPickUpDispo,
    setEditShipperClicked,
    setIsLoading,
    addNewPickUpDispo,
    editShipperClicked,
    isOrderScreen,
 
  } = props;

  const [searchText, setSearchText] = useState("");
  const[showActiveBillTo,setShowActiveBillTo]=useState(true)

  const handleSearchText = (event) => {
    setSearchText(event);
    if (event === "") {
      handleSearch("");
    }
  };
  const handleSearch = (searchName) => {
    
      setIsLoading(true)
      billToTableApiCall(
        { page: 1, pageSize: 50 },
       "",
        searchName,
        "",
      );
    
}
  useEffect(() => {}, [rows]);

  const handleQueryPageChange = (
    params,
    sortData = {
      field: "name",
      sort: "asc",
    },
   
  ) => {
    setSelectedRow("");
      billToTableApiCall(
        { page: params?.page + 1, pageSize: params?.pageSize },
        sortData,
        searchText,
        "",
      );
  };
  const handleSortChange = (
    params,
    sortData = {
      field: "name",
      sort: "asc",
    }
  ) => {
    setSelectedRow("");
      billToTableApiCall(
        { page: params?.page + 1, pageSize: params?.pageSize },
        sortData,
        searchText,
        "",
      );
  };
  const ShowActiveBillToDataHandler =(data)=>{
    setShowActiveBillTo(data)
    if(data===false){
      billToTableApiCall(
        { page: 1, pageSize: 50 },
       "",
       searchText,
        "all",
      );

    }else{
      billToTableApiCall(
        { page: 1, pageSize: 50 },
       "",
       searchText,
        "A",
      );
    }

  }

  return (
    <PermissionWrapper category="orderby" level="VIEW_ONLY">
    <Paper
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          width: "100%",
          height: "40px",
          backgroundColor: "#E4EEFA",
          alignItems: "center",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <label style={{ fontSize: "14px", color: "#091DA3" }}>
          List Bill To
        </label>
      </div>

      <div
        style={{
          width: "100%",
          height: "50px",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          padding: "10px",
        }}
      >
        <div
          style={{
            width: "60%",
            height: "40px",
            display: "flex",
            alignItems: "center",
            marginRight: "4%",
          }}
        >
          <TextField
            label="Search"
            margin="dense"
            style={{ height: "40px", width: "100%", fontSize: "10px" }}
            size="small"
            inputProps={{ style: { fontSize: 10 } }}
            InputLabelProps={{ style: { fontSize: 14, height: 40 } }}
            value={searchText}
            
            onChange={(event) => {
              handleSearchText(event.target.value);
            }}
            onKeyPress={(event) => {
              event.key === "Enter" && handleSearch(event.target.value);
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment>
                  <IconButton
                    onClick={() => {
                      searchText ? handleSearchText("") : handleSearch();
                    }}
                  >
                    {searchText ? <CloseIcon /> : <SearchIcon />}
                  </IconButton>
                  
                </InputAdornment>
              ),
            }}
          />
        </div>
       <div
        style={{
          width: "40%",
          height: "40px",
          display: "flex",
          alignItems: "center",
        }}
      >
        <FormControlLabel
                control={
                  <Checkbox
                  onChange={(e) =>ShowActiveBillToDataHandler(e.target.checked)}
                    checked={showActiveBillTo}
                    color="primary"
                  />
                }
                label={
                    <Typography sx={{ fontSize: '0.8rem' }}>
                      Show only active Bill To's
                    </Typography>
                  }
              
              />
              </div>
       
      </div>

      <div style={{ width: "100%", height: "100%" }}>

        {/* {shipperSearchError ? (
          <div style={{ color: "red", textAlign: "center" }}>
            {shipperSearchError}
          </div>
        ) :
         ( */}
          <BillToTable 
            rows={rows}
            isLoading={isLoading}
            setSelectedRow={setSelectedRow}
            handleQueryPageChange={handleQueryPageChange}
            handleSortChangeData={handleSortChange}
            rowsCount={rowsCount}
            setAddNewPickUpDispo={setAddNewPickUpDispo}
            billToTableApiCall={billToTableApiCall}
            setEditShipperClicked={setEditShipperClicked}
            editShipperClicked={editShipperClicked}
            addNewPickUpDispo={addNewPickUpDispo}
            isOrderScreen={isOrderScreen}
          />
        {/* )} */}
      </div>

    </Paper>
    </PermissionWrapper>
  );
}
